export type WorkspaceRuntime = { mode: 'real' | 'demo'; allowSyntheticData: boolean };

/** Missing or contradictory runtime metadata must never enable demo controls. */
export function allowsSyntheticData(runtime?: WorkspaceRuntime): boolean {
  return runtime?.mode === 'demo' && runtime.allowSyntheticData === true;
}

export function scopedSyntheticFlag(requested: boolean, runtime?: WorkspaceRuntime): boolean {
  return requested === true && allowsSyntheticData(runtime);
}

export function workspaceLabel(runtime?: WorkspaceRuntime): string {
  return runtime?.mode === 'real'
    ? 'Real workspace · Saved CRM data'
    : runtime?.mode === 'demo'
      ? 'Demo workspace · Demonstration data'
      : 'Workspace mode unavailable';
}

/** A rate requires an observed denominator; no observations are not a zero rate. */
export function percentage(numerator: number, denominator: number): string {
  return Number.isFinite(numerator) && Number.isFinite(denominator) && denominator > 0
    ? `${Math.round((numerator / denominator) * 100)}%`
    : '—';
}
